import { apiToken, ledgerURLWithOrg } from "../config"

export const getLadgerDataWithOrg = async ({ organizationId, page=1, limit=50, startedAt, endedAt, type, source }) => {
    try {
        const response = await fetch(`${ledgerURLWithOrg}${organizationId}?page=${page}&limit=${limit}&startDate=${startedAt}&endDate=${endedAt}&type=${type}&source=${source}`,{
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}`
            }
        } );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const res = await response.json();
        return res.data;
    } catch(e) {
        console.error("Error fetching ledger data:", e);
        throw e;
    }

}